<template>
       <span>
           <tippani-header subject="Application for visa transfer"/>
           <p>
               I would like to request you to transfer my visa in the new Passport/Travel Documents from the old Passport/from your records. Transfer fee and other related documents are attached here within.
           </p>
           <div>
                  <table style="width: 100%;">
                <tr>
                    <td>Submission Id:</td>
                    <td>{{data.submission_no}}</td>
                </tr>
                <tr>
                    <td>Current Visa number:</td>
                    <td>{{data.visa.visa_number}} (Expiry At: {{data.visa.expiry_date}}</td>
                </tr>
                <tr>
                    <td>Full Name</td>
                    <td>{{data.traveller.name}}</td>
                </tr>
                <tr>
                    <td>Old Passport Number:</td>
                    <td>{{data.traveller.passport_number}}</td>
                </tr>

                <tr>
                    <td>New Document Type:</td>
                    <td>{{data.transfer_data.document_type}}</td>
                </tr>   <tr>
                    <td>New Document Number:</td>
                    <td>{{data.transfer_data.document_number}}</td>
                </tr>
                <tr>
                    <td>Transfer cost ($):</td>
                    <td>
                        {{data.transfer_data.cost}}
                    </td>
                </tr>
                <tr v-if="data.voucher_number">
                    <td>Voucher number:</td>
                    <td>
                        {{data.voucher_number}}
                    </td>
                </tr>
            </table>
           </div>
           <div v-html="content"></div>
       <div style="margin-top: 10px;">
            Prepared by : <b>{{created_by}} </b>
        </div>
    </span>
</template>

<script>
    import TippaniHeader from "./TippaniHeader";

    export default {
        name: "TransferTippani",
        computed: {
            content() {
                if (this.$store.state.Transfer.transferDetail.tippani_content)
                    return this.$store.state.Transfer.transferDetail.tippani_content;

                return this.$store.state.Tippani.tippaniContent;
            },
            data() {
                return this.$store.state.Transfer.transferDetail;
            },
            created_by() {
                let roles = this.$store.state.AuthUser.user.roles;
                roles = roles[0];
                return this.$store.state.AuthUser.user.full_name + ' (' + roles.display_name + ')';
            }
        },
        components: {
            TippaniHeader
        }
    }
</script>

<style scoped>
    table, th, td {
        border: 1px solid black;
    }

    table {
        border-collapse: separate;
        border-spacing: 1px;
        border-left: 0;
        border-bottom: 0;
    }

    td, th {
        border-top: 0;
        border-right: 0;
        padding: 5px;
    }

    .td-font-bold {
        font-weight: bold;
    }
</style>
